import { PageTypePortal } from "@/lib/types";

export const PASSWORD_CHANGED_QUERY_PARAM = "passwordChanged";

/** Login URL shown after a successful change-password (message on sign-in page). */
export function buildLoginUrlAfterPasswordChange(callbackUrl?: string | null): string {
  const params = new URLSearchParams();
  params.set(PASSWORD_CHANGED_QUERY_PARAM, "1");
  if (callbackUrl?.trim()) {
    params.set("callbackUrl", callbackUrl.trim());
  }
  return `${PageTypePortal.Login}?${params.toString()}`;
}

export function isPasswordChangedLoginMessage(
  searchParams: URLSearchParams | { get: (key: string) => string | null },
): boolean {
  return searchParams.get(PASSWORD_CHANGED_QUERY_PARAM) === "1";
}
